export const MerchantListUat = {
  title: 'merchantSelection.merchantList.title',
  listItems: 'merchantSelection.merchantList.listItems',
  loadMoreButton: 'merchantSelection.merchantList.loadMoreButton'
}
